<template>
    <section class="gmp-section gmp-mb-l">
        <div class="highlights-module">
            <div class="h-c-page">
                <div class="h-c-grid highlights-module__sticky-wrapper">
                    <div class="h-c-grid__col h-c-grid__col-l--6">
                        <div class="highlights-module__sticky-el">
                            <img src="@/assets/img/zhiyingMain.png" class="gmp-no-grab highlights-module__image-desktop"
                                 alt="">
                        </div>
                    </div>

                    <div class="h-c-grid__col h-c-grid__col-l--5 highlights-module__content">
                        <h3 class="h-c-headline h-c-headline--one h-has-bottom-margin">
                            简单易用的系统
                        </h3>
                        <p></p>
                        <picture>
                            <img src="@/assets/img/zhiyingMain.png" alt=""
                                 class="gmp-no-grab highlights-module__image-mobile">
                        </picture>

                        <div class="highlights-module__listing">
                            <ul class="highlights-module__highlights">

                                <li class="highlights-module__highlight">
                                    <picture>
                                        <img src="@/assets/img/1a.png" alt=""
                                             class="gmp-circle-icon gmp-circle-icon--yellow highlights-module__icon">
                                    </picture>
                                    <h4 class="h-c-headline h-c-headline--four h-has-bottom-margin">
                                        实时更新库存
                                    </h4>
                                    <p>后厨人员直接参与库存管理和订货，他们可以根据实际使用情况调整库存数据。</p>
                                </li>
                                <li class="highlights-module__highlight">
                                    <picture>
                                        <img src="@/assets/img/1a.png" alt=""
                                             class="gmp-circle-icon gmp-circle-icon--yellow highlights-module__icon">
                                    </picture>
                                    <h4 class="h-c-headline h-c-headline--four h-has-bottom-margin">
                                        提高运营效率
                                    </h4>
                                    <p>
                                        后厨人员直接参与库存管理和订货，减少了沟通和审批的环节，使订货流程更为简化和高效。
                                    </p>
                                </li>

                                <li class="highlights-module__highlight">
                                    <picture>
                                        <img src="@/assets/img/1a.png" alt=""
                                             class="gmp-circle-icon gmp-circle-icon--yellow highlights-module__icon">
                                    </picture>
                                    <h4 class="h-c-headline h-c-headline--four h-has-bottom-margin">
                                        实时数据分析
                                    </h4>
                                    <p>系统提供的实时数据分析功能可以让管理层快速掌握门店运营情况，如销售趋势、库存水平和成本变动，从而快速做出决策，调整运营策略，提高响应市场变化的能力。</p>
                                </li>

<!--                                <li class="highlights-module__highlight">-->
<!--                                    <picture>-->
<!--                                        <img src="@/assets/img/1a.png" alt=""-->
<!--                                             class="gmp-circle-icon gmp-circle-icon&#45;&#45;yellow highlights-module__icon">-->
<!--                                    </picture>-->
<!--                                    <h4 class="h-c-headline h-c-headline&#45;&#45;four h-has-bottom-margin">-->
<!--                                        优化库存管理-->
<!--                                    </h4>-->
<!--                                    <p>库房端的功能可以有效管理库存的出入库记录，减少过量库存和库存积压，确保库存的高周转率和低损耗，避免资金被不必要地占用。</p>-->
<!--                                </li>-->
<!--                                <li class="highlights-module__highlight">-->
<!--                                    <picture>-->
<!--                                        <img src="@/assets/img/1a.png" alt=""-->
<!--                                             class="gmp-circle-icon gmp-circle-icon&#45;&#45;yellow highlights-module__icon">-->
<!--                                    </picture>-->
<!--                                    <h4 class="h-c-headline h-c-headline&#45;&#45;four h-has-bottom-margin">-->
<!--                                        规范化操作-->
<!--                                    </h4>-->
<!--                                    <p>中央厨房端使得食材加工和准备工作可以在中央厨房集中进行，然后分配到各个门店，这样可以标准化食品的质量和口味，减少分店之间的差异。</p>-->
<!--                                </li>-->
<!--                                <li class="highlights-module__highlight">-->
<!--                                    <picture>-->
<!--                                        <img src="@/assets/img/1a.png" alt=""-->
<!--                                             class="gmp-circle-icon gmp-circle-icon&#45;&#45;yellow highlights-module__icon">-->
<!--                                    </picture>-->
<!--                                    <h4 class="h-c-headline h-c-headline&#45;&#45;four h-has-bottom-margin">-->
<!--                                        增强透明度-->
<!--                                    </h4>-->
<!--                                    <p>整个系统的使用增加了业务流程的透明度，管理层可以随时查看各个环节的操作详情，有效监控和预防潜在的风险和错误。-->

<!--                                    </p>-->
<!--                                </li>-->

                            </ul>

                            <a @click="toEnterprisePage('/enterprise/directStore/DS_Benefit','/enterprise/directStore/DS_Benefit')" class="h-c-link gmp-link">
                                查看所有优点
                            </a>
                        </div>



                    </div>


                </div>


                <div class="highlights-module__carousel highlights-module__carousel--horizontal">

                    <div class="glue-pagination h-c-carousel h-c-carousel--simple ng-isolate-scope glue-o-pagination">

                        <div class="h-c-carousel__wrap ng-scope">
                            <ul class="glue-carousel glue-is-ready" id="highlightsUl"
                                style="width: auto; transform: none">
                                <li class="h-c-carousel__item">
                                    <picture>
                                        <img src="@/assets/img/1a.png" alt=""
                                             class="gmp-circle-icon gmp-circle-icon--yellow highlights-module__icon">
                                    </picture>
                                    <h4 class="h-c-headline h-c-headline--four highlights-module__subhead">
                                        高效的供应链管理
                                    </h4>
                                    <div class="highlights-module__description">
                                        <p>确保食材的新鲜度，减少库存成本，并确保餐厅在任何时候都有足够的库存来满足顾客需求。通过使用现代化的采购系统和供应链管理软件，企业可以在这方面获得显著的提升。</p>
                                    </div>

                                </li>
                                <li class="h-c-carousel__item">
                                    <picture>
                                        <img src="@/assets/img/1a.png" alt=""
                                             class="gmp-circle-icon gmp-circle-icon--yellow highlights-module__icon">
                                    </picture>
                                    <h4 class="h-c-headline h-c-headline--four highlights-module__subhead">
                                        成本控制和规模经济
                                    </h4>
                                    <div class="highlights-module__description">
                                        <p>通过集中采购和统一管理，直营连锁餐饮企业可以实现规模经济，从而降低单位成本，提高利润率。</p>
                                    </div>

                                </li>
                                <li class="h-c-carousel__item">
                                    <picture>
                                        <img src="@/assets/img/1a.png" alt=""
                                             class="gmp-circle-icon gmp-circle-icon--yellow highlights-module__icon">
                                    </picture>
                                    <h4 class="h-c-headline h-c-headline--four highlights-module__subhead">
                                        实时数据分析
                                    </h4>
                                    <div class="highlights-module__description">
                                        <p>系统提供的实时数据分析功能可以让管理层快速掌握门店运营情况，如销售趋势、库存水平和成本变动，从而快速做出决策，调整运营策略，提高响应市场变化的能力。</p>
                                    </div>

                                </li>
<!--                                <li class="h-c-carousel__item">-->
<!--                                    <picture>-->
<!--                                        <img src="@/assets/img/1a.png" alt=""-->
<!--                                             class="gmp-circle-icon gmp-circle-icon&#45;&#45;yellow highlights-module__icon">-->
<!--                                    </picture>-->
<!--                                    <h4 class="h-c-headline h-c-headline&#45;&#45;four highlights-module__subhead">-->
<!--                                        实时数据分析-->
<!--                                    </h4>-->
<!--                                    <div class="highlights-module__description">-->
<!--                                        <p>系统提供的实时数据分析功能可以让管理层快速掌握门店运营情况，如销售趋势、库存水平和成本变动，从而快速做出决策，调整运营策略，提高响应市场变化的能力。</p>-->
<!--                                    </div>-->

<!--                                </li>-->


                            </ul>
                        </div>

                        <div class="h-c-carousel__navigation product-card-grid__navigation ng-scope">
                            <ul class="glue-pagination-page-list ng-isolate-scope glue-o-pagination__page-list">
                                <li :class="{active:0 === activeIndex}"
                                    class=" glue-o-pagination__button-container  glue-o-pagination__page-list-button-container ng-scope "
                                    @click="showIndex(0)">
                                    <button class="glue-o-pagination__button glue-o-pagination__page-list-button ng-binding ng-scope"></button>
                                </li>
                                <li :class="{active:1 === activeIndex}"
                                    class="glue-o-pagination__button-container glue-o-pagination__page-list-button-container ng-scope"
                                    @click="showIndex(1)">
                                    <button class="glue-o-pagination__button glue-o-pagination__page-list-button ng-binding ng-scope"></button>
                                </li>
                                <li :class="{active:2 === activeIndex}"
                                    class="glue-o-pagination__button-container glue-o-pagination__page-list-button-container ng-scope"
                                    @click="showIndex(2)">
                                    <button class="glue-o-pagination__button glue-o-pagination__page-list-button ng-binding ng-scope"
                                    ></button>
                                </li>
                                <li :class="{active:3 === activeIndex}"
                                    class="glue-o-pagination__button-container glue-o-pagination__page-list-button-container ng-scope"
                                    @click="showIndex(3)">
                                    <button class="glue-o-pagination__button glue-o-pagination__page-list-button ng-binding ng-scope"
                                    ></button>
                                </li>



                                <div style="clear:both;"></div>

                            </ul>

                        </div>

                    </div>

                    <div class="highlights-module__cta highlights-module__cta--mobile">
                        <a @click="toEnterprisePage('/enterprise/directStore/DS_Benefit','/enterprise/directStore/DS_Benefit')"  class="h-c-link gmp-link">
                            查看所有特点
                        </a>
                    </div>

                </div>

            </div>

        </div>

    </section>
</template>

<script>
    export default {
        name: "Enter_highLights",
        props: ['clientWidth'],
        data() {
            return {
                activeIndex: 0,
                itemWidth: ""
            }
        },

        watch: {
            clientWidth: function (val) {
                this.clientWidth = val
                this.changeFixed(this.clientWidth)
            },
        },


        methods: {
            showIndex(data) {
                // var itemWidth = this.$('.h-c-carousel__item').width();


                if(this.clientWidth < 600){
                    var itemWidth1 = this.$('.h-c-carousel').width();
                    var moveWidth1 = "";

                    moveWidth1 = - + data * itemWidth1;
                    console.log("1=====" + moveWidth1)
                    moveWidth1 = Number(moveWidth1) + Number(20)
                    console.log("2======" + moveWidth1);
                    this.$('#highlightsUl').css({
                        "transform": "translate3d(" + moveWidth1 + "px, 0px, 0px)",
                        "transition": "transform .4s"
                    })
                }else{
                    var itemWidth = this.$('.h-c-carousel').width();
                    var moveWidth = "";
                    moveWidth = - + data * itemWidth;
                    moveWidth = Number(moveWidth);
                    this.$('#highlightsUl').css({
                        "transform": "translate3d(" + moveWidth + "px, 0px, 0px)",
                        "transition": "transform .4s"
                    })
                }

                this.activeIndex = data;
            },


            changeFixed(data) {
                this.activeIndex = 0;
                var itemWidth = this.$('.h-c-carousel').width();
                var items = this.$('.h-c-carousel__item');
                var how = this.clientWidth * 5;
                for (var j = 0; j < items.length; j++) {
                    this.$(items[j]).css({
                        'width': itemWidth + 'px',
                        "min-width": "149px"
                    })
                }
                if (data < 1024) {
                    if (data < 600) {

                        if (this.activeIndex === 0) {
                            this.$('#highlightsUl').css({
                                'width': how + 'px',
                                "transform": "translate3d(20px, 0px,0px)",
                            })
                        } else {
                            var how1 = (Number(this.clientWidth) - Number(20)) * 5;
                            console.log("dayu600 < 1024")
                            this.$('#highlightsUl').css({
                                'width': how1 + 'px',
                                "transform": "translate3d(20px, 0px,0px)",
                            })
                        }

                    } else{
                        this.$('#highlightsUl').css({
                            'width': how + 'px',
                            "transform": "translate3d(0px, 0px,0px)",
                        })

                    }


                } else {
                    this.$('#highlightsUl').css({
                        'width': "auto",
                        "transform": "translate3d(0px, 0px,0px)",
                    })
                }
            },



            toEnterprisePage(data, url) {
                this.$router.push(data)
                this.$('body').removeClass('h-is-showing-drawer');
                var lis = this.$('.h-c-header__drawer-nav-li-link');
                for (var i = 0; i < lis.length; i++) {
                    var toWhere = this.$(lis[i]).attr('to-where');
                    console.log("toWhere===" + toWhere);
                    if (toWhere === url) {
                        this.$(lis[i]).addClass('h-is-active');
                    } else {
                        this.$(lis[i]).removeClass('h-is-active')
                    }
                }
            },
        }


    }
</script>

<style lang="less">



</style>